export default {_name:'text.property',module:'Field',view:'Element/Text/Property',options:{xs:12}}